/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Opravář [HTML elementů](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement).
 */
class HtmlElementRepairer {
  /**
   * Obnoví HTML element do výchozího stavu.
   *
   * Důležité je, aby bylo uvolněno maximální množství paměti.
   * Nastavují se pouze známé vlastnosti daného elementu,
   * ostatní jsou ignorovány.
   * Atributy elementu jsou odstraněny vždy.
   * Do obnovení není zahrnuta změna DOM struktury a propojení jejích uzlů.
   *
   * Do obnovení nejsou zahrnuty vlastnosti pro callback funkce jako je
   * např. [onclick](https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onclick).
   * Uživatel elementu by měl vždy využívat alternativní naslouchání pomocí
   * [EventTarget](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget).
   * Uživatel je zároveň zodpovědný za to,
   * že všechny svoje naslouchání před opravou odebere.
   * @param {HTMLElement} el Element k opravení.
   * @param {Object} [opts={}]
   * @param {Array.<string>} [opts.omitAttributes=[]] Seznam názvů atributů, které při čištění přeskočit.
   * @returns {Promise.<undefined>} Vyřeší se, jakmile je element opraven.
   */
  repair(el, { omitAttributes = [] } = {}) {
    return new Promise((resolve) => {
      // Odeberou se všechny standardní a nestandardní atributy.
      // U nově vytvořeného elementu žádné atributy nejsou.
      Array.from(el.attributes)
        .filter((attribute) => !omitAttributes.includes(attribute.name))
        .forEach((attribute) => {
          el.removeAttribute(attribute.name);
        });
      // Reset scrollování v elementu.
      // Není možné použít metod `scroll` nebo `scrollTo`,
      // které nejsou na starších prohlížečích dostupné.
      el.scrollLeft = 0;
      el.scrollTop = 0;
      return resolve();
    });
  }
}

export default HtmlElementRepairer;
